import { createReducer, on } from '@ngrx/store';
import { setPremiumTotalValueAction } from './premiumTotalValue.actions';


export const initialState = 0;

export const premiumTotalValueReducer = createReducer(
  initialState,
  on(setPremiumTotalValueAction, (state, { premiumTotalValue }) => premiumTotalValue)
);